import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaModalOverlayRef } from '@global-front-components/ui/modal-overlay';
import { TranslateModule } from '@ngx-translate/core';
import { Recibo } from '../../model/poliza.model';

@Component({
	selector: 'app-modal-informacion-tarificacion',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule
	],
	templateUrl: './modal-informacion-tarificacion.component.html',
	styleUrls: ['./modal-informacion-tarificacion.component.scss']
})
export class ModalInformacionTarificacionComponent implements OnInit {
	@Input() data!: any;
	recibo: Recibo;
	
	constructor(
		private _modalRef: CaModalOverlayRef<ModalInformacionTarificacionComponent>,		
	) { }

	ngOnInit(): void {
		this.recibo = this.data?.recibo;
	}

	closeDialog(text?: string): void {
		if (text) {
			this._modalRef.close(text);
		} else {
			this._modalRef.close();
		}
	}
}
